<script lang="ts">
    import type { PageProps } from '@kestrel/server';
    import ApmBoundary from '@shared/components/apm-boundary/ApmBoundary.svelte';
    import TileListFallbackRoute from '@tilelist/application/wiring/TileListFallbackRoute.svelte';

    let { data }: PageProps<typeof import('./page.server.ts')> = $props();
</script>

<ApmBoundary scope="tilelist-fallback">
    <TileListFallbackRoute result={data} />

    {#snippet failed()}
        <TileListFallbackRoute result={{ state: 'error' }} />
    {/snippet}
</ApmBoundary>
